import React from "react";
import { Report } from "../../types/report.type";
import { Image, Spin, Table } from "antd";
import { API } from "../../config/config";

interface ReportsProps {
  data: Report[] | null;
  loading: boolean;
}

export default function RecentReports({ data, loading }: ReportsProps) {
  if (loading) {
    return <Spin size="large" />;
  }

  if (!data) {
    return <div>No data available</div>;
  }

  const columns = [
    {
      title: "Дата",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Фото",
      key: "snapshot",
      dataIndex: "snapshot",
      render: (snapshot: string) => (
        <div>
          <Image
            key={snapshot}
            src={`${API}/${snapshot}`}
            width={50}
            height={50}
            preview={{ src: `${API}/${snapshot}` }}
            alt="Фото"
            loading="lazy"
            style={{
              cursor: "pointer",
              borderRadius: 4,
              border: "1px solid #ddd",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
            }}
          />
        </div>
      ),
    },
    {
      title: "Имя",
      dataIndex: "warehouseMgrName",
      key: "warehouseMgrName",
    },
    {
      title: "Детали",
      key: "details",
      render: (_: any, record: Report) => {
        return (
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              gap: "8px",
              maxWidth: "900px",
              margin: 0,
              padding: 0,
            }}
          >
            {record.details.map((detail, index) => (
              <p key={index}>
                {index + 1}.{detail.produceName}, Кол-во:{detail.quantity}, КГ:
                {detail.quantityKg},Отход:{detail.wasteProduced} , Статус:
                {detail.quantityKgStatus}
              </p>
            ))}
          </div>
        );
      },
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ textAlign: "center" }}>
        Отчёты производства (ниже-выше 5 дней)
      </h2>

      <div style={{ marginTop: "20px", maxHeight: "300px", overflowY: "auto" }}>
        <Table
          dataSource={data}
          columns={columns}
          rowKey={(record) => record._id}
          pagination={false}
          scroll={{ y: 240, x: "max-content" }}
        />
      </div>
    </div>
  );
}
